import React from "react";
import { Link } from "react-router-dom";
import DoneIcon from "@mui/icons-material/Done";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
//Side-Images
import MRIImage from "../../assets/final-images/servicepage/mainservicepage/Artboard 1.jpg";
import PETImage from "../../assets/final-images/servicepage/mainservicepage/Artboard 2.jpg";
import personalinjury from "../../assets/final-images/servicepage/mainservicepage/Artboard 3.jpg";
import VascularImage from "../../assets/final-images/servicepage/mainservicepage/Artboard 4.jpg";
import ProstateImage from "../../assets/final-images/servicepage/mainservicepage/Artboard 5.jpg";
import womenimaging from "../../assets/final-images/servicepage/mainservicepage/Artboard 6.jpg";
import CTImage from "../../assets/final-images/servicepage/mainservicepage/Artboard 7.jpg";
import NuclearMedicineImage from "../../assets/final-images/servicepage/mainservicepage/Artboard 8.jpg";
import UltraSoundImage from "../../assets/final-images/servicepage/mainservicepage/Artboard 9.jpg";
import DigitalXRay from "../../assets/final-images/servicepage/mainservicepage/Artboard 10.jpg";
import BoneImage from "../../assets/final-images/servicepage/mainservicepage/Artboard 11.jpg";

export default function ServicesDetails() {
  return (
    <div>
      {/* MRI Section */}
      <div
        style={{
          background:
            "linear-gradient(to right, #3d0e26 0%, #8b5e3c 50%,  #330a16 100%)",
        }}
        className="py-10 xl:py-24"
      >
        <div className="grid xl:grid-cols-2 grid-cols-1 gap-8 md:max-w-[90%] w-11/12 mx-auto xl:py-28 xl:px-14 py-10 px-0 bg-transparent xl:bg-[#0f0f0f] rounded-xl justify-center items-center">
          <div className="order-1 xl:order-1">
            <div className="pb-8">
              <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  capitalize ">
                MRI (Magnetic Resonance Imaging)
              </h2>
              <p className=" text-[#cccccc]  font-normal ">
                Advanced MRI with comfort and diagnostic confidence.
              </p>
            </div>
            <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2 ">
              <li className="flex items-start gap-2">
                <DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                <span>Wide-Bore High-Field MRI (1.5 Tesla)</span>
              </li>

              <li className="flex items-start gap-2">
                <DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                <span>Open & Bariatric MRI (80-cm Open-Bore MRI)</span>
              </li>

              <li className="flex items-start gap-2">
                <DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                <span>Neuroimaging (Brain MRI)</span>
              </li>

              <li className="flex items-start gap-2">
                <DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                <span>Brain DTI (Traumatic Brain Injury)</span>
              </li>

              <li className="flex items-start gap-2">
                <DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                <span>Spine MRI & Whiplash Protocols</span>
              </li>

              <li className="flex items-start gap-2">
                <DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                <span>Musculoskeletal MRI (Joints & Soft Tissue)</span>
              </li>

              <li className="flex items-start gap-2">
                <DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                <span>Body MRI</span>
              </li>

              <li className="flex items-start gap-2">
                <DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                <span>Prostate MRI (Multiparametric)</span>
              </li>
            </ul>
            <p className="py-2">
              MRI exams are performed in permanent, purpose-built imaging suites
              and interpreted by radiologists with subspecialty expertise.
            </p>
            <div className="py-10">
              <Link
                data-aos="fade-up"
                to="/open-mri-and-imaging"
                aria-label="MRI"
                className="px-8 py-2.5 rounded-3xl bg-white text-black font-bold hover:bg-black hover:border hover:text-white border border-[#ffffff5d] transition-all duration-300"
              >
                Learn more
              </Link>
            </div>
          </div>
          <div className=" order-2 xl:order-2">
            <img
              src={MRIImage}
              alt="MRI"
              className=" rounded-3xl w-auto h-auto"
            />
          </div>
        </div>
      </div>
      {/* MRI Section */}
      {/* PRT Section */}
      <div className="py-10 xl:py-24">
        <div className="grid xl:grid-cols-2 grid-cols-1 gap-8 md:max-w-[90%] w-11/12 mx-auto xl:py-28 xl:px-14 py-10 px-0  bg-transparent xl:bg-[#0f0f0f] rounded-xl justify-center items-center">
          <div className=" order-2 xl:order-1">
            <img
              src={PETImage}
              alt="PET(Positron Emission Tomography)-CT(Computed Tomography)"
              className=" rounded-3xl w-auto h-auto "
            />
          </div>
          <div className="order-1 xl:order-2 xl:ps-10 ps-0">
            <div className="pb-8">
              <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  capitalize">
                PET-CT (Positron Emission Tomography-Computed Tomography)
              </h2>
              <p className="text-[#cccccc] font-normal">
                Molecular imaging guided by experience.
              </p>
            </div>
            <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
              <li className="flex items-start gap-2">
                <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e]" />
                <span>Oncology PET-CT</span>
              </li>

              <li className="flex items-start gap-2">
                <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e]" />
                <span>PSMA Prostate PET-CT</span>
              </li>

              <li className="flex items-start gap-2">
                <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e]" />
                <span>Neuroendocrine Tumor PET-CT</span>
              </li>

              <li className="flex items-start gap-2">
                <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e]" />
                <span>Brain PET-CT for Alzheimer’s Disease</span>
              </li>
            </ul>
            <p className="py-2">
              PET-CT studies are radiologist-led from protocol selection through
              interpretation, reflecting deep experience in molecular imaging.
            </p>
            <div className="py-10">
              <Link
                data-aos="fade-up"
                to="/pet-scan-imaging"
                aria-label="MRI"
                className="px-8 py-2.5 rounded-3xl bg-white text-black font-bold hover:bg-black hover:border hover:text-white border border-[#ffffff5d] transition-all duration-300"
              >
                Learn more
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* PET Section */}
      {/* PIP Section */}
      <div
        style={{
          background:
            "linear-gradient(to right, #3d0e26 0%, #8b5e3c 50%,  #330a16 100%)",
        }}
        className="py-10 xl:py-24"
      >
        <div className="grid xl:grid-cols-2 grid-cols-1 gap-8 md:max-w-[90%] w-11/12 mx-auto xl:py-28 xl:px-14 py-10 px-0  bg-transparent xl:bg-[#0f0f0f] rounded-xl justify-center items-center">
          <div className="order-1 xl:order-1">
            <div className="pb-8">
              <h2 className="lg:text-[38px] text-[24px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading  capitalize  ">
                Personal Injury / Workers' Compensation
              </h2>
              {/* <p>
                Auto Accident (PIP) Imaging, Slip and Fall / LOP Services,
                Attorney Portal.
              </p> */}
              <p className=" text-[#cccccc] font-normal">
                Diagnostic reliability when details matter.
              </p>
            </div>
            <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
              <li className="flex items-start gap-2">
                <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                <span>MRI, CT, X-Ray, Ultrasound</span>
              </li>

              <li className="flex items-start gap-2">
                <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                <span>Nuclear Medicine Bone Scan</span>
              </li>

              <li className="flex items-start gap-2">
                <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                <span>Traumatic Brain Injury Imaging</span>
              </li>

              <li className="flex items-start gap-2">
                <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                <span>Spine & Ligament Evaluation</span>
              </li>

              <li className="flex items-start gap-2">
                <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                <span>
                  Concierge coordination for attorneys, providers, and patients
                </span>
              </li>

              <li className="flex items-start gap-2">
                <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                <span>Secure digital image and record sharing</span>
              </li>
            </ul>
            <div className="py-10">
              <Link
                data-aos="fade-up"
                to="/personal-injury"
                aria-label="Personal Injury / Workers' Compensation"
                className="px-8 py-2.5 rounded-3xl bg-white text-black font-bold hover:bg-black hover:border hover:text-white border border-[#ffffff5d] transition-all duration-300"
              >
                Learn more
              </Link>
            </div>
          </div>
          <div className=" order-2 xl:order-2">
            <img
              src={personalinjury}
              alt="Personal Injury / Workers' Compensation"
              className=" rounded-3xl w-auto h-auto "
            />
          </div>
        </div>
      </div>
      {/* PIP Section */}
      {/* Cardiac Section */}
      <div className="py-10 xl:py-24">
        <div className="grid xl:grid-cols-2 grid-cols-1 gap-8 md:max-w-[90%] w-11/12 mx-auto xl:py-28 xl:px-14 py-10 px-0  bg-transparent xl:bg-[#0f0f0f] rounded-xl justify-center items-center">
          <div className="order-2 xl:order-1">
            <img
              src={VascularImage}
              alt="Cardiac & Vascular Imaging"
              className=" rounded-3xl w-auto h-auto "
            />
          </div>
          <div className="order-1 xl:order-2 xl:ps-10 ps-0">
            <div className="pb-8">
              <h2 className="lg:text-[38px] text-[24px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading  capitalize ">
                Cardiac & Vascular Imaging
              </h2>
              <p className=" text-[#cccccc] font-normal ">
                Early detection. Objective assessment.
              </p>
            </div>
            <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2 ">
              <li className="flex items-start gap-2">
                <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e]" />
                <span>Coronary CT Angiography (CTA)</span>
              </li>

              <li className="flex items-start gap-2">
                <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e]" />
                <span>CT Coronary Calcium Scoring</span>
              </li>

              <li className="flex items-start gap-2">
                <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e]" />
                <span>Echocardiography</span>
              </li>

              <li className="flex items-start gap-2">
                <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e]" />
                <span>Cardiac Nuclear Medicine</span>
              </li>

              {/* Parent item with nested list */}
              <li className="space-y-2">
                <div className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e]" />
                  <span>Vascular Ultrasound Imaging:</span>
                </div>

                {/* Sub list */}
                <ul className="pl-6 space-y-2">
                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e]" />
                    <span>Carotid artery evaluation</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e]" />
                    <span>Abdominal aortic aneurysm (AAA) screening</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e]" />
                    <span>Peripheral arterial disease</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e]" />
                    <span>Venous disease</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e]" />
                    <span>
                      Renal artery evaluation for suspected renovascular
                      hypertension
                    </span>
                  </li>
                </ul>
              </li>
            </ul>
            <p className=" py-5">
              Independent, radiologist-led imaging supports objective
              cardiovascular evaluation.
            </p>
            <div className="py-10">
              <Link
                data-aos="fade-up"
                to="/cardiac-imaging"
                aria-label="MRI"
                className="px-8 py-2.5 rounded-3xl bg-white text-black font-bold hover:bg-black hover:border hover:text-white border border-[#ffffff5d] transition-all duration-300"
              >
                Learn more
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* Cardiac Section */}
      {/* Prostate Section */}
      <div
        style={{
          background:
            "linear-gradient(to right, #3d0e26 0%, #8b5e3c 50%,  #330a16 100%)",
        }}
        className="py-10 xl:py-24"
      >
        <div className="grid xl:grid-cols-2 grid-cols-1 gap-8 md:max-w-[90%] w-11/12 mx-auto xl:py-28 xl:px-14 py-10 px-0  bg-transparent xl:bg-[#0f0f0f] rounded-xl justify-center items-center">
          <div className="order-1 xl:order-1">
            <div className="pb-8">
              <h2 className="lg:text-[38px] text-[24px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading  capitalize ">
                Prostate Imaging
              </h2>
              <p className="text-[#cccccc] font-normal">
                Integrated MRI and PET imaging for prostate cancer.
              </p>
            </div>
            <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2 ">
              <li className="flex items-start gap-2">
                <DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                <span>Multiparametric Prostate MRI</span>
              </li>

              <li className="flex items-start gap-2">
                <DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                <span>Advanced Prostate PET Imaging</span>
              </li>

              <li className="flex items-start gap-2">
                <DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                <span>
                  Imaging for initial diagnosis, staging, recurrence, and
                  surveillance
                </span>
              </li>
            </ul>
            <p className=" py-2">
              Prostate imaging is approached as an integrated strategy-not a
              single test.
            </p>
            <div className="py-10">
              <Link
                data-aos="fade-up"
                to="/prostate-on-mri"
                aria-label="MRI"
                className="px-8 py-2.5 rounded-3xl bg-white text-black font-bold hover:bg-black hover:border hover:text-white border border-[#ffffff5d] transition-all duration-300"
              >
                Learn more
              </Link>
            </div>
          </div>
          <div className=" order-2 xl:order-2">
            <img
              src={ProstateImage}
              alt="Prostate Imaging"
              className=" rounded-3xl w-auto h-auto "
            />
          </div>
        </div>
      </div>
      {/* Prostate Section */}
      {/* Women's Section */}
      <div className="py-10 xl:py-24">
        <div className="grid xl:grid-cols-2 grid-cols-1 gap-8 md:max-w-[90%] w-11/12 mx-auto xl:py-28 xl:px-14 py-10 px-0  bg-transparent xl:bg-[#0f0f0f] rounded-xl justify-center items-center">
          <div className="order-2 xl:order-1">
            <img
              src={womenimaging}
              alt="Women’s Imaging"
              className=" rounded-3xl w-auto h-auto "
            />
          </div>
          <div className="order-1 xl:order-2 xl:ps-10 ps-0">
            <div className="pb-8">
              <h2 className="lg:text-[38px] text-[24px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading  capitalize  ">
                Women’s Imaging
              </h2>
              <p className=" text-[#cccccc] font-normal ">
                Focused on early detection. Designed around you.
              </p>
            </div>
            <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
              <li className="flex items-start gap-2">
                <DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                <span>3D Mammography (Tomosynthesis)</span>
              </li>

              <li className="flex items-start gap-2">
                <DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                <span>Breast Ultrasound</span>
              </li>

              <li className="flex items-start gap-2">
                <DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                <span>Breast MRI</span>
              </li>

              <li className="flex items-start gap-2">
                <DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                <span>
                  Risk-Based Breast Imaging (including Tyrer-Cuzick assessment)
                </span>
              </li>
            </ul>
            <p className=" py-2">
              Comprehensive breast imaging delivered with attention to comfort,
              safety, and personalized risk.
            </p>
            <div className="py-10">
              <Link
                data-aos="fade-up"
                to="/womens-imaging-center"
                aria-label="MRI"
                className="px-8 py-2.5 rounded-3xl bg-white text-black font-bold hover:bg-black hover:border hover:text-white border border-[#ffffff5d] transition-all duration-300"
              >
                Learn more
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* Women's Section */}
      {/* Other Section */}
      <div
        style={{
          background:
            "linear-gradient(to right, #3d0e26 0%, #8b5e3c 50%,  #330a16 100%)",
        }}
        className="py-10 xl:py-24"
        id="ct"
      >
        <div className="grid xl:grid-cols-2 grid-cols-1 gap-8 md:max-w-[90%] w-11/12 mx-auto xl:py-28 xl:px-14 py-10 px-0  bg-transparent xl:bg-[#0f0f0f] rounded-xl justify-center items-center">
          <div className="order-1 xl:order-1">
            <div className="pb-8">
              <h2 className="lg:text-[38px] text-[24px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading  capitalize">
                CT (Computed Tomography)
              </h2>
              <p className=" text-[#cccccc] font-normal ">
                Fast, detailed imaging with dose-conscious design.
              </p>
            </div>
            <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2 ">
              <li className="flex items-start gap-2">
                <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e]" />
                <span>Low-Dose Lung Cancer Screening CT</span>
              </li>

              <li className="flex items-start gap-2">
                <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e]" />
                <span>Diagnostic CT (Head, Chest, Abdomen, Pelvis)</span>
              </li>

              <li className="flex items-start gap-2">
                <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e]" />
                <span>Trauma & Emergency CT</span>
              </li>

              <li className="flex items-start gap-2">
                <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e]" />
                <span>CT for Personal Injury / PIP cases</span>
              </li>
            </ul>
          </div>
          <div className="order-2 xl:order-2">
            <img
              src={CTImage}
              alt="CT(Computed Tomography)"
              className=" rounded-3xl w-auto h-auto "
            />
          </div>
        </div>
      </div>
      <div className="py-10 xl:py-24" id="nuclear-medicine">
        <div className="grid xl:grid-cols-2 grid-cols-1 gap-8 md:max-w-[90%] w-11/12 mx-auto xl:py-28 xl:px-14 py-10 px-0  bg-transparent xl:bg-[#0f0f0f] rounded-xl justify-center items-center">
          <div className="order-2 xl:order-1">
            <img
              src={NuclearMedicineImage}
              alt="Nuclear Medicine"
              className=" rounded-3xl w-auto h-auto "
            />
          </div>
          <div className="order-1 xl:order-2 xl:ps-10 ps-0">
            <div className="pb-8">
              <h2 className="lg:text-[38px] text-[24px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading  capitalize ">
                Nuclear Medicine
              </h2>
              <p className=" text-[#cccccc] font-normal">
                Functional imaging that complements anatomy.
              </p>
            </div>
            <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
              <li className="flex items-start gap-2">
                <DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                <span>General Nuclear Medicine</span>
              </li>

              <li className="flex items-start gap-2">
                <DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                <span>Bone Scan</span>
              </li>

              <li className="flex items-start gap-2">
                <DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                <span>Cardiac Nuclear Medicine</span>
              </li>

              <li className="flex items-start gap-2">
                <DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                <span>DAT Scan (Neuroimaging)</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div
        style={{
          background:
            "linear-gradient(to right, #3d0e26 0%, #8b5e3c 50%,  #330a16 100%)",
        }}
        className="py-10 xl:py-24"
        id="ultrasound"
      >
        <div className="grid xl:grid-cols-2 grid-cols-1 gap-8 md:max-w-[90%] w-11/12 mx-auto xl:py-28 xl:px-14 py-10 px-0  bg-transparent xl:bg-[#0f0f0f] rounded-xl justify-center items-center">
          <div className="order-1 xl:order-1">
            <div className="pb-8">
              <h2 className="lg:text-[38px] text-[24px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading  capitalize ">
                Ultrasound
              </h2>
              <p className=" text-[#cccccc] font-normal">
                Real-time imaging without radiation.
              </p>
            </div>
            <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
              <li className="flex items-start gap-2">
                <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e]" />
                <span>Abdominal & Pelvic Ultrasound</span>
              </li>

              <li className="flex items-start gap-2">
                <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e]" />
                <span>Vascular Ultrasound</span>
              </li>

              <li className="flex items-start gap-2">
                <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e]" />
                <span>Musculoskeletal Ultrasound</span>
              </li>

              <li className="flex items-start gap-2">
                <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e]" />
                <span>Soft Tissue Ultrasound</span>
              </li>
            </ul>
          </div>
          <div className="order-2 xl:order-2">
            <img
              src={UltraSoundImage}
              alt="Ultrasound"
              className=" rounded-3xl w-auto h-auto "
            />
          </div>
        </div>
      </div>
      <div className="py-10 xl:py-24" id="digital-xray">
        <div className="grid xl:grid-cols-2 grid-cols-1 gap-8 md:max-w-[90%] w-11/12 mx-auto xl:py-28 xl:px-14 py-10 px-0  bg-transparent xl:bg-[#0f0f0f] rounded-xl justify-center items-center">
          <div className="order-2 xl:order-1 ">
            <img
              src={DigitalXRay}
              alt="Digital X-Ray"
              className=" rounded-3xl w-auto h-auto "
            />
          </div>
          <div className="order-1 xl:order-2 xl:ps-10 ps-0">
            <div className="pb-8">
              <h2 className="lg:text-[38px] text-[24px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading  capitalize">
                Digital X-Ray
              </h2>
              <p className=" text-[#cccccc] font-normal">
                Efficient imaging for a wide range of conditions.
              </p>
            </div>
            <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
              <li className="flex items-start gap-2">
                <DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                <span>General Diagnostic X-Ray</span>
              </li>

              <li className="flex items-start gap-2">
                <DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                <span>Trauma & Musculoskeletal X-Ray</span>
              </li>

              <li className="flex items-start gap-2">
                <DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                <span>Auto / PIP / Personal Injury Imaging</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div
        style={{
          background:
            "linear-gradient(to right, #3d0e26 0%, #8b5e3c 50%,  #330a16 100%)",
        }}
        className="py-10 xl:py-24"
      >
        <div className="grid xl:grid-cols-2 grid-cols-1 gap-8 md:max-w-[90%] w-11/12 mx-auto xl:py-28 xl:px-14 py-10 px-0  bg-transparent xl:bg-[#0f0f0f] rounded-xl justify-center items-center">
          <div className="order-1 xl:order-1 xl:pl-10 pl-0 ">
            <div className="pb-8">
              <h2 className="lg:text-[38px] text-[24px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading  capitalize  ">
                Bone Health & Body Composition
              </h2>
              <p className=" text-[#cccccc] font-normal">
                Objective assessment of fracture risk and body composition.
              </p>
            </div>
            <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
              <li className="flex items-start gap-2">
                <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                <span>
                  DEXA Body Composition Analysis offers insight into fat mass,
                  lean muscle mass, and distribution, and may be used as part of
                  overall health assessment, metabolic evaluation, or wellness
                  monitoring.
                </span>
              </li>
            </ul>
            <p className=" py-2">
              All DEXA studies are performed using modern, low-dose imaging and
              interpreted by qualified imaging professionals.
            </p>
          </div>
          <div className="order-2 xl:order-2">
            <img
              src={BoneImage}
              alt="Bone Health & Body Composition"
              className=" rounded-3xl w-auto h-auto "
            />
          </div>
        </div>
      </div>
    </div>
  );
}
